import { ProtectedJsonAPI } from './ProtectedJsonAPI'

export const Versions = ProtectedJsonAPI.extend(
  'versions',
  {
    index:   endpoint => endpoint,
  }
)